export default "/images/Rule6-5video.jpg";